export const siteManageVisitorKey = 'manageVisitors';
export const siteRequiresPassKey = 'requiresPass';
export const siteRequiresPhotoKey = 'requiresPhoto';
export const siteRequiresPhotoIdKey = 'requiresIdPhoto';
export const siteRequiresPhoneKey = 'requiresPhone';
export const visitorPurposes = 'purposes';

export const VISITOR_PHOTO_TYPE = {
  NOT_ALLOWED: { id: 'NOT_ALLOWED', name: 'Not Allowed' },
  OPTIONAL: { id: 'OPTIONAL', name: 'Optional' },
  REQUIRED: { id: 'REQUIRED', name: 'Required' },
};

export const VISITOR_PASS_TYPE = {
  NO: { id: 'NO', name: 'Not Required' },
  SPECIFIC_PASS: { id: 'SPECIFIC_PASS', name: 'Specific Pass' },
  GLOBAL: { id: 'GLOBAL', name: 'Global' },
};

export const VISITOR_PHOTO_OPTIONS = [
  VISITOR_PHOTO_TYPE.NOT_ALLOWED,
  VISITOR_PHOTO_TYPE.OPTIONAL,
  VISITOR_PHOTO_TYPE.REQUIRED,
];

export const VISITOR_PASS_OPTIONS = [
  VISITOR_PASS_TYPE.NO,
  VISITOR_PASS_TYPE.SPECIFIC_PASS,
  VISITOR_PASS_TYPE.GLOBAL,
];

export const SITE_POLICY_DEFAULT_VALUES = {
  [siteRequiresPassKey]: VISITOR_PASS_TYPE.NO.id,
  [siteRequiresPhotoKey]: VISITOR_PHOTO_TYPE.OPTIONAL.id,
  [siteRequiresPhotoIdKey]: VISITOR_PHOTO_TYPE.OPTIONAL.id,
  [siteRequiresPhoneKey]: false,
  [visitorPurposes]: [],
};
